var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80623 6.59489C8.32311 6.59489 8.83999 6.36145 9.2159 5.98793L11.8943 3.09318C12.0352 2.95311 12.0352 2.71966 11.8943 2.5796C11.7533 2.43953 11.5184 2.43953 11.3774 2.5796L8.83999 4.774C8.74601 4.86738 8.55806 4.86738 8.41709 4.774C8.32311 4.68062 8.32311 4.49387 8.41709 4.3538L10.6726 1.83256C10.8135 1.69249 10.8135 1.45905 10.6726 1.31898C10.5316 1.17891 10.2967 1.17891 10.1557 1.31898L7.57129 3.56008C7.47731 3.65345 7.28936 3.65345 7.14839 3.56008C7.05441 3.4667 7.05441 3.27994 7.14839 3.13987L9.40386 0.618636C9.54483 0.478567 9.54483 0.24512 9.40386 0.105051C9.26289 -0.0350173 9.02795 -0.0350173 8.88698 0.105051L5.97366 2.71966C5.55076 3.09318 5.31582 3.65345 5.36281 4.21373L5.4098 4.96076C5.4098 5.2409 5.31582 5.52103 5.08087 5.70779L0.428967 9.81647C-0.134901 10.2834 -0.134901 11.1238 0.381978 11.6374C0.898857 12.1509 1.74466 12.1043 2.21455 11.5907L6.39657 6.92172C6.58452 6.73496 6.81947 6.59489 7.1014 6.59489L7.80623 6.59489Z",
    fill: "#16201D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/fork.0717ac71.svg";
export { ForwardRef as ReactComponent };